// @ts-check
import { Bar, BarChart, Cell, XAxis, YAxis } from 'recharts';
import BlockCard from '../BlockCard';

/** Unanswered contact messages split by how long they have waited. */
export default function ContactBlock({ block }) {
  const { unanswered = 0, oldest_days: oldest = null, age_buckets: ages = {} } = block.data || {};
  const bars = [
    { name: '<1d', value: ages.lt_1d || 0, fill: '#22c55e' },
    { name: '1-2d', value: ages.d1_2 || 0, fill: '#f59e0b' },
    { name: '>2d', value: ages.gt_2d || 0, fill: '#ef4444' },
  ];

  return (
    <BlockCard title="Contact messages" href={block.href} headline={block.headline}>
      {unanswered > 0 ? (
        <div data-testid="contact-chart" className="overflow-x-auto">
          <BarChart width={240} height={110} data={bars} aria-hidden="true">
            <XAxis dataKey="name" tickLine={false} axisLine={false} fontSize={12} />
            <YAxis hide allowDecimals={false} />
            <Bar dataKey="value" isAnimationActive={false}>
              {bars.map((b) => (
                <Cell key={b.name} fill={b.fill} />
              ))}
            </Bar>
          </BarChart>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">Inbox is clear</p>
      )}
      {unanswered > 0 && oldest !== null && (
        <p data-testid="contact-oldest" className="mt-2 text-sm text-muted-foreground">Oldest waiting {oldest}d</p>
      )}
    </BlockCard>
  );
}
